import { Box, Pagination, Paper, Skeleton, useMediaQuery } from "@mui/material";
import { NewsItem } from "./NewsItem";
import { useOrganizationStore } from "../../../store/organization.store";
import { useEffect, useState } from "react";

export function NewsPage() {
    const isMobile = useMediaQuery("(max-width:1100px)");
    const { posts, getPosts, total_posts } = useOrganizationStore();
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                await getPosts((page - 1) * 10);
            } catch (error) {
            } finally {
                setLoading(false);
            }
        })();
    }, [page]);

    return (
        <Box>
            <h1
                style={{
                    marginBottom: "30px",
                }}
            >
                Новости
            </h1>
            {loading ? (
                <Paper
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        padding: isMobile ? "24px" : "24px 240px",
                        gap: "24px",
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                        }}
                    >
                        <Skeleton
                            variant="text"
                            sx={{ fontSize: "2em" }}
                            width={400}
                        />
                        <Skeleton
                            variant="rectangular"
                            width={200}
                            sx={{
                                marginBottom: "8px",
                            }}
                        />
                        <Skeleton
                            variant="rectangular"
                            height={200}
                            sx={{
                                marginBottom: "8px",
                                borderRadius: "8px",
                            }}
                        />
                        {/* For other variants, adjust the size with `width` and `height` */}
                        <Skeleton variant="rectangular" height={400} />
                    </Box>
                </Paper>
            ) : (
                <Paper
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        padding: isMobile ? "24px" : "24px 240px",
                        gap: "24px",
                    }}
                >
                    {posts.map((n) => {
                        return <NewsItem post={n} />;
                    })}
                    <Pagination
                        page={page}
                        onChange={(event, page) => setPage(page)}
                        count={
                            Math.floor(total_posts / 10) +
                            (total_posts % 10 == 0 ? 0 : 1)
                        }
                    />
                </Paper>
            )}
        </Box>
    );
}
